import React from "react";
import AakashgangaHeader from "../../components/global/HeaderComponent";
import AakashgangaFooter from "../../components/global/FooterComponent";
import ReactPlayer from "react-player/youtube";
import arrowLeft from "../../assets/img/icons/arrow_left.svg";
import { useNavigate } from "react-router-dom";
import "./gyankosh.scss";

import { blogArticles } from "./data";

const GyanKosh = () => {
  const navigate = useNavigate();

  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  return (
    <div className="tagbody">
      <AakashgangaHeader />
      <div className="resourceSection innerPages" style={{ background: "#ffffff", backgroundImage: "none" }}>
        <div className="containWrap gyankosh-container">
          <div className="sub-nav-bar">
            <a href="/GyanKosh" className="sub-nav-item active">GYAN KOSH</a>
            <a href="/all-research-articles" target="_blank" rel="noopener noreferrer" className="sub-nav-item">ARTICLES</a>
            <a href="/presentations" target="_blank" rel="noopener noreferrer" className="sub-nav-item">QUICK LEARNS</a>
            <a href="/browse" target="_blank" rel="noopener noreferrer" className="sub-nav-item">VIDEOS</a>
            <a href="/playlist" target="_blank" rel="noopener noreferrer" className="sub-nav-item">PLAYLISTS</a>
          </div>

          <div className="gyankosh-header">
            <h1>Gyan Kosh</h1>
            <p>
              Must-read academic blog for researchers and PhD students—it’s a great way to pickup chatter about what’s brewing in scholarly publishing.
            </p>
          </div>

          <div className="gyankosh-grid">
            {blogArticles.map((article) => (
              <div className="gyankosh-card-col" key={article.id}>
                <div className="gyankosh-card">
                  <div className="card-img-wrap">
                    <a onClick={(e) => handleRedirect(e, `/GyanKosh/${article.slug}`)} style={{cursor: "pointer"}}>
                      <img src={article.image} alt={article.title} />
                    </a>
                  </div>
                  <div className="card-content">
                    <a onClick={(e) => handleRedirect(e, `/GyanKosh/${article.slug}`)} style={{cursor: "pointer"}} className="card-title">
                      {article.title}
                    </a>
                    <div className="card-date">{article.date}</div>
                    <div className="card-excerpt">{article.excerpt}</div>
                    <a onClick={(e) => handleRedirect(e, `/GyanKosh/${article.slug}`)} style={{cursor: "pointer"}} className="read-more-btn">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="founder-section">
            <div className="founder-row">
              <div className="founder-video-col">
                <div className="video-wrapper">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=Iewt4-w2R9g"
                    playing={false}
                    controls={true}
                    width="100%"
                    height="280px"
                  />
                </div>
              </div>
              <div className="founder-text-col">
                <h2>Message from the founder</h2>
                <p>
                  Vikramshila is a mission. Listen to our founder talk about the dream that is Vikramshila.
                </p>
                <a
                  href="https://www.youtube.com/watch?v=Iewt4-w2R9g"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="watch-btn"
                >
                  Watch Video
                </a>
              </div>
            </div>
          </div>

          <div className="row align-items-center justify-content-between contentFooter" style={{ marginTop: "40px" }}>
            <div className="col-auto">
              <a onClick={(e) => handleRedirect(e, '/resourcecentre')} className="goBack" href="/resourcecentre">
                Back
                <b>
                  <img src={arrowLeft} alt="#" />
                </b>
              </a>
            </div>
            <div
              className="pullUp"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <b className="icon-arrow-right" />
            </div>
          </div>
        </div>
      </div>
      <AakashgangaFooter />
    </div>
  );
};

export default GyanKosh;
